import angular from 'angular';

angular.module(APP_NAME)
    .config(config);

/* @ngInject */
function config ($compileProvider) {
	$compileProvider.debugInfoEnabled(false);
}


/** WEBPACK FOOTER **
 ** ./src/config/production.config.js
 **/